<template>
  <div>
    <Loader v-if="loading"></Loader>
    <div class="wrraper" v-else>
      <!-- Start Breadcrumb -->
      <Breadcrumb
        :items="items"
        :show_print="true"
        :excelFile="true"
        :excelData="excelData"
      />
      <!-- End Breadcrumb -->
      <!-- start of searchSection  -->
      <SearchSection @filterTable="searchTable"></SearchSection>
      <!-- end of searchSection  -->
      <!-- notFound  -->
      <Notfound v-if="!searchItems"></Notfound>
      <!-- Start Statistics Card-->
      <div v-else>
        <!-- Start Statistics Card-->
        <ul class="all-state-count">
          <li>
            <div class="state-count">
              <span> عدد الموظفين :</span>
              <span>{{ table_length }}</span>
            </div>
          </li>
        </ul>
        <!-- End Statistics Card-->

        <main class="main-table table-print">
          <!-- start of  header of printSection  -->
          <PrintHead :title="'الموظفين'" :number="table_length"></PrintHead>
          <!-- end of header of printSection  -->
          <v-data-table
            class="thumb"
            :headers="headers"
            :items="rows"
            :loading="lodaing"
            :loading-text="$t('table.loadingData')"
            v-model="selected"
            :single-select="singleSelect"
            item-key="id"
            :items-per-page="rows.length"
            hide-default-footer
          >
            <!-- ================== You Can use any slots you want ================== -->
            <!-- Select no data State -->
            <template v-slot:[`item.index`]="{ index }">
              {{ index + 1 }}
            </template>
            <template v-slot:[`item.wallets`]="{ item }">
              <ChipCollapse
                :items="item.wallets"
                label-key="name"
                color="grey darken-3"
              />
            </template>

            <template v-slot:[`item.in_wallets`]="{ item }">
              <ChipCollapse
                :items="item.in_wallets"
                label-key="name"
                color="grey darken-3"
              />
            </template>

            <template v-slot:[`item.permissions`]="{ item }">
              <ChipCollapse
                :items="item.permissions"
                label-key="title"
                color="blue"
              />
            </template>
            <template v-slot:[`item.customers`]="{ item }">
              <span v-if="item.customers.length == 0"> كل العملاء </span>
              <ChipCollapse
                v-else
                :items="item.customers"
                label-key="name"
                color="blue"
                removable
                @remove="askRemoveCustomer(item, $event)"
              />
            </template>
            <template v-slot:no-data>
              {{ $t("table.noData") }}
            </template>

            <!-- Ban switcher -->
            <template v-slot:[`item.is_ban`]="{ item }">
              <button
                type="button"
                role="switch"
                class="ban-switch"
                :class="{ blocked: item.is_ban }"
                :aria-checked="String(!item.is_ban)"
                :title="item.is_ban ? 'محظور - اضغط لفك الحظر' : 'نشط - اضغط للحظر'"
                @click="askToggleBlock(item)"
              >
                <span class="ban-label on">نشط</span>
                <span class="ban-label off">محظور</span>
                <span class="ban-knob">
                  <i class="fal fa-check ic-on"></i>
                  <i class="fal fa-ban ic-off"></i>
                </span>
              </button>
            </template>

            <!-- Select actions-->
            <template v-slot:[`item.actions`]="{ item }">
              <div class="_actions">
                <v-icon class="edit" small @click="editItem(item)">
                  fal fa-edit
                </v-icon>
                <v-icon class="delete" small @click="deleteItem(item)">
                  fal fa-trash
                </v-icon>
              </div>
            </template>

            <!-- ======================== Start Top Section ======================== -->
            <template v-slot:top>
              <!-- Remove customer access dialog -->
              <v-dialog
                v-model="dialogCustomer"
                max-width="460px"
                content-class="cust-dialog"
              >
                <div class="cust-card" :class="{ breaking: breakHover }">
                  <div class="cust-glow"></div>
                  <button
                    type="button"
                    class="cust-close"
                    :disabled="loadingCustomer"
                    @click="dialogCustomer = false"
                  >
                    <i class="fal fa-times"></i>
                  </button>

                  <span class="cust-tag">
                    <i class="fal fa-shield-exclamation"></i> منطقة حساسة
                  </span>
                  <h3>فصل حساب العميل عن الموظف</h3>

                  <!-- animated link between employee and customer -->
                  <div class="cust-link">
                    <div class="cust-node emp">
                      <div class="cust-avatar">
                        {{ initial(customerToRemove.employee.name) }}
                      </div>
                      <small>الموظف</small>
                      <b>{{ customerToRemove.employee.name }}</b>
                    </div>

                    <div class="cust-chain">
                      <span class="seg left"></span>
                      <i class="fal fa-link main"></i>
                      <i class="fal fa-unlink broken"></i>
                      <span class="seg right"></span>
                    </div>

                    <div class="cust-node cus">
                      <div class="cust-avatar">
                        {{ initial(customerToRemove.customer.name) }}
                      </div>
                      <small>العميل</small>
                      <b>{{ customerToRemove.customer.name }}</b>
                    </div>
                  </div>

                  <ul class="cust-notes">
                    <li>
                      <i class="fal fa-eye-slash"></i>
                      لن يتمكن الموظف من رؤية حساب هذا العميل
                    </li>
                    <li>
                      <i class="fal fa-history"></i>
                      يمكن إعادة الصلاحية لاحقاً من شاشة التعديل
                    </li>
                  </ul>

                  <div class="cust-actions">
                    <button
                      type="button"
                      class="cust-btn danger"
                      :disabled="loadingCustomer"
                      @mouseenter="breakHover = true"
                      @mouseleave="breakHover = false"
                      @click="removeCustomerConfirm"
                    >
                      <span v-if="!loadingCustomer">
                        <i class="fal fa-unlink"></i> فصل الآن
                      </span>
                      <span v-else class="cust-spin"></span>
                    </button>
                    <button
                      type="button"
                      class="cust-btn ghost"
                      :disabled="loadingCustomer"
                      @click="dialogCustomer = false"
                    >
                      تراجع
                    </button>
                  </div>
                </div>
              </v-dialog>

              <!-- Ban / unban confirmation dialog -->
              <v-dialog
                v-model="dialogBlock"
                max-width="420px"
                content-class="ban-dialog"
                :persistent="loadingBlock"
              >
                <div class="ban-card" :class="blockTarget.willBlock ? 'is-ban' : 'is-unban'">
                  <div class="ban-icon">
                    <i
                      class="fal"
                      :class="blockTarget.willBlock ? 'fa-user-lock' : 'fa-user-check'"
                    ></i>
                  </div>
                  <h3>
                    {{ blockTarget.willBlock ? "حظر الموظف" : "فك حظر الموظف" }}
                  </h3>
                  <p>
                    {{
                      blockTarget.willBlock
                        ? "هل أنت متأكد من حظر الموظف"
                        : "هل أنت متأكد من فك الحظر عن الموظف"
                    }}
                    <b>{{ blockTarget.employee.name }}</b> ؟
                  </p>
                  <small>
                    {{
                      blockTarget.willBlock
                        ? "لن يتمكن من تسجيل الدخول حتى تقوم بفك الحظر."
                        : "سيتمكن من تسجيل الدخول واستخدام النظام مجدداً."
                    }}
                  </small>
                  <div class="ban-actions">
                    <button
                      type="button"
                      class="ban-btn confirm"
                      :disabled="loadingBlock"
                      @click="blockConfirm"
                    >
                      <span v-if="!loadingBlock">
                        {{ blockTarget.willBlock ? "نعم، حظر" : "نعم، فك الحظر" }}
                      </span>
                      <span v-else class="ban-spin"></span>
                    </button>
                    <button
                      type="button"
                      class="ban-btn ghost"
                      :disabled="loadingBlock"
                      @click="dialogBlock = false"
                    >
                      إلغاء
                    </button>
                  </div>
                </div>
              </v-dialog>

              <!-- Delete dialog -->
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5 justify-center">{{
                    $t("table.deletedialog.areYouSure")
                  }}</v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#1B5E20" @click="deleteItemConfirm"
                      >{{ $t("table.deletedialog.ok") }}
                      <span
                        class="btn_loader_model"
                        v-if="loadingBtnDialog"
                      ></span
                    ></v-btn>
                    <v-btn color="#F44336" @click="dialogDelete = false">{{
                      $t("table.deletedialog.cancel")
                    }}</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- Add & Delete -->

              <!-- Add & Delete -->
            </template>
            <!-- ======================== End Top Section ======================== -->
          </v-data-table>
        </main>
        <!-- End Main Section -->
      </div>

      <!-- Start Image_Model -->
      <base-model
        @closeModel="model_1.show_model = false"
        :show="model_1.show_model"
      >
        <div class="image">
          <img
            v-if="model_1.model_img_src"
            :src="model_1.model_img_src"
            alt="..."
          />
        </div>
      </base-model>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import StatsCard from "./../../../components/Charts/ChartComponent.vue";
import SearchSection from "@/components/Search/employees";
import ChipCollapse from "@/components/Table/ChipCollapse.vue";
export default {
  components: {
    ChipCollapse,
    StatsCard,
    SearchSection,
  },

  data() {
    return {
      // loadingBtnDialog
      loadingBtnDialog: false,
      // search
      searchItems: null,
      // loader
      loading: true,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.employees.title"),
          disabled: false,
          href: "/sliders",
        },
        {
          text: this.$t("breadcrumb.employees.all"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Statistics
      statisticsItems: [
        {
          id: 1,
          icon: "fal fa-images",
          title: "الموظفين",
          number: "1",
        },
      ],

      // ========== dialog Status
      dialogShow: false,
      itemToShow: null,
      dialogDelete: false,
      dialogDelete_selected: false,
      // remove customer access
      dialogCustomer: false,
      loadingCustomer: false,
      breakHover: false,
      // ban employee
      dialogBlock: false,
      loadingBlock: false,
      blockTarget: { employee: {}, willBlock: true },
      customerToRemove: { employee: {}, customer: {} },
      itemtoDelete: null,

      // ========== Date_Menues
      from_date_menu: false,
      to_date_menu: false,

      // ========== Filter
      filter: {
        name: null,
        safe: [],
        from: null,
        to: null,
      },

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },

      // ========== Body Section
      calories: "",

      // ========== Your Data
      rows: [], // injected in created

      // ========== elected Data
      selected: [],
      singleSelect: false,

      // ========== Loding
      lodaing: false,

      // Fixed_data
      safes: ["foo", "bar", "fizz", "buzz"],
      table_length: null,
      // excel data
      excelData: {
        name: "الموظفين",
        items: null,
        json_fields: {
          "اسم الموظف": "name",
          الفرع: "branch.name_ar",
          "البريد الالكتروني": "email",
          "خزن الموظف سحب": {
            field: "in_wallets",
            callback: (value) => {
              let finalVal = "<table><tbody>";
              value.forEach((val, index) => {
                if (index == value.length - 1) {
                  finalVal +=
                    "<tr><td>" + val.name + "</td></tr>" + "</tbody></table>";
                } else {
                  finalVal += "<tr><td>" + val.name + "</td></tr>";
                }
              });
              return finalVal;
            },
          },
          "خزن الموظف ايداع": {
            field: "wallets",
            callback: (value) => {
              let finalVal = "<table><tbody>";
              value.forEach((val, index) => {
                if (index == value.length - 1) {
                  finalVal +=
                    "<tr><td>" + val.name + "</td></tr>" + "</tbody></table>";
                } else {
                  finalVal += "<tr><td>" + val.name + "</td></tr>";
                }
              });
              return finalVal;
            },
          },
          "صلاحيات الموظف": {
            field: "permissions",
            callback: (value) => {
              let finalVal = "<table><tbody>";
              value.forEach((val, index) => {
                if (index == value.length - 1) {
                  finalVal +=
                    "<tr><td>" + val.title + "</td></tr>" + "</tbody></table>";
                } else {
                  finalVal += "<tr><td>" + val.title + "</td></tr>";
                }
              });
              return finalVal;
            },
          },
        },
        "حسابات العملاء": {
          field: "customers",
          callback: (value) => {
            let finalVal = "<table><tbody>";
            value.forEach((val, index) => {
              if (index == value.length - 1) {
                finalVal +=
                  "<tr><td>" + val.title + "</td></tr>" + "</tbody></table>";
              } else {
                finalVal += "<tr><td>" + val.title + "</td></tr>";
              }
            });
            return finalVal;
          },
        },
      },
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            value: "index",
            sortable: false,
            align: "center",
            width: 10,
          },
          { text: "اسم الموظف", value: "name", align: "center" },
          { text: "الفرع ", value: "branch.name_ar", align: "center" },
          {
            text: "البريد الالكتروني",
            value: "email",
            align: "center",
          },
          {
            text: "خزن الموظف سحب",
            value: "in_wallets",
            align: "center",
            sortable: false,
          },
          {
            text: "خزن الموظف ايداع",
            value: "wallets",
            align: "center",
            sortable: false,
          },
          {
            text: "صلاحيات الموظف",
            value: "permissions",
            align: "center",
            sortable: false,
          },
          {
            text: "حسابات العملاء",
            value: "customers",
            align: "center",
            sortable: false,
          },
          {
            text: "كود الموظف",
            value: "user_code",
            align: "center",
            sortable: false,
          },
          {
            text: "الحظر",
            value: "is_ban",
            align: "center",
            sortable: false,
          },
          {
            text: "التحكم",
            value: "actions",
            sortable: false,
            align: "center",
            class: "showOnPrint",
            cellClass: "showOnPrint",
            width: 100,
          },
        ];
      }
    },
  },

  methods: {
    // searchTable
    searchTable(items) {
      this.rows = [];
      this.searchItems = items;
      this.setRows();
    },
    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },

    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/employees/add" });
    },
    showItem(item) {
      this.dialogShow = true;
      this.itemToShow = item;
    },
    editItem(item) {
      this.$router.push({ path: "/employees/edit/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.loadingBtnDialog = true;
      this.$axios({
        method: "DELETE",
        url: `client/user/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.loadingBtnDialog = false;
          this.setRows();
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "topRight",
          });
          this.$store.dispatch("getTranshState");
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "topRight",
          });
        });
    },
    // ===== Ban / unban employee
    askToggleBlock(employee) {
      this.blockTarget = { employee, willBlock: !employee.is_ban };
      this.dialogBlock = true;
    },
    blockConfirm() {
      const { employee, willBlock } = this.blockTarget;
      this.loadingBlock = true;
      this.$axios({
        method: "POST",
        url: `client/user/ban/${employee.id}`,
      })
        .then((res) => {
          this.loadingBlock = false;
          this.dialogBlock = false;
          this.$set(employee, "is_ban", willBlock);
          this.$iziToast.success({
            timeout: 2000,
            message:
              (res.data && res.data.message) ||
              (willBlock ? "تم حظر الموظف" : "تم فك الحظر"),
            position: "topRight",
          });
        })
        .catch((err) => {
          this.loadingBlock = false;
          this.$iziToast.error({
            timeout: 2000,
            message:
              (err.response && err.response.data && err.response.data.message) ||
              err.message,
            position: "topRight",
          });
        });
    },
    initial(name) {
      return name ? String(name).trim().charAt(0) : "?";
    },
    // ===== Remove customer access
    askRemoveCustomer(employee, customer) {
      this.customerToRemove = { employee, customer };
      this.breakHover = false;
      this.dialogCustomer = true;
    },
    removeCustomerConfirm() {
      const { employee, customer } = this.customerToRemove;
      this.loadingCustomer = true;
      this.$axios({
        method: "POST",
        url: `client/user/delete_customer_access/${employee.id}/${
          customer.balance_customer_id || customer.id
        }`,
      })
        .then((res) => {
          this.loadingCustomer = false;
          this.dialogCustomer = false;
          this.setRows();
          this.$iziToast.success({
            timeout: 2000,
            message: (res.data && res.data.message) || this.$t("deleteSuccess"),
            position: "topRight",
          });
        })
        .catch((err) => {
          this.loadingCustomer = false;
          this.$iziToast.error({
            timeout: 2000,
            message:
              (err.response && err.response.data && err.response.data.message) ||
              err.message,
            position: "topRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // Set Rows
    setRows() {
      this.lodaing = true;
      this.$axios({
        method: "GET",
        url: "client/user",
        params: {
          branch_id: this.searchItems ? this.searchItems.branchId : null,
          user_code: this.searchItems ? this.searchItems.userCode : null,
        },
      })
        .then((res) => {
          this.rows = res.data.data;
          this.table_length = this.rows.length;
          this.excelData.items = this.rows;
          this.lodaing = false;
        })
        .catch((err) => {
          this.lodaing = false;
        });
    },
  },

  // ======= hooks
  created() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
// dialog content is rendered outside this component, so use ::v-deep
::v-deep .cust-dialog {
  overflow: visible;
  box-shadow: none;
  .cust-card {
    position: relative;
    overflow: hidden;
    padding: 30px 26px 24px;
    border-radius: 24px;
    text-align: center;
    color: #37474f;
    background: linear-gradient(160deg, #ffffff 0%, #f3f6fd 100%);
    box-shadow: 0 25px 60px rgba(30, 40, 90, 0.25);
  }
  .cust-glow {
    position: absolute;
    top: -90px;
    left: 50%;
    width: 280px;
    height: 180px;
    transform: translateX(-50%);
    background: radial-gradient(
      circle,
      rgba(255, 82, 82, 0.22),
      transparent 70%
    );
    pointer-events: none;
  }
  .cust-close {
    position: absolute;
    top: 14px;
    left: 14px;
    width: 30px;
    height: 30px;
    border: 0;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.05);
    color: #546e7a;
    cursor: pointer;
    transition: 0.2s;
    &:hover {
      background: rgba(0, 0, 0, 0.12);
      transform: rotate(90deg);
    }
  }
  .cust-tag {
    position: relative;
    display: inline-block;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 12px;
    color: #ff8a80;
    background: rgba(255, 82, 82, 0.14);
    border: 1px solid rgba(255, 82, 82, 0.35);
  }
  h3 {
    position: relative;
    margin: 14px 0 26px;
    font-size: 20px;
    color: #1a237e;
  }

  // ---- employee <-> customer
  .cust-link {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    margin-bottom: 22px;
  }
  .cust-node {
    flex: 0 0 110px;
    display: flex;
    flex-direction: column;
    align-items: center;
    small {
      margin-top: 8px;
      font-size: 11px;
      color: #78909c;
    }
    b {
      max-width: 110px;
      font-size: 13px;
      font-weight: 600;
      word-break: break-word;
    }
  }
  .cust-avatar {
    width: 62px;
    height: 62px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    transition: transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
  .emp .cust-avatar {
    background: linear-gradient(135deg, #5c6bc0, #3949ab);
    box-shadow: 0 8px 20px rgba(92, 107, 192, 0.45);
  }
  .cus .cust-avatar {
    background: linear-gradient(135deg, #29b6f6, #0277bd);
    box-shadow: 0 8px 20px rgba(41, 182, 246, 0.4);
  }

  .cust-chain {
    position: relative;
    flex: 1;
    height: 62px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 36px;
    .seg {
      position: absolute;
      top: 50%;
      height: 0;
      border-top: 2px dashed rgba(0, 0, 0, 0.25);
      transition: all 0.45s ease;
      &.left {
        right: 0;
        width: 50%;
      }
      &.right {
        left: 0;
        width: 50%;
      }
    }
    i {
      position: relative;
      z-index: 1;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      background: #fff;
      transition: all 0.4s;
    }
    .main {
      color: #78909c;
      border: 1px solid rgba(0, 0, 0, 0.18);
    }
    .broken {
      position: absolute;
      color: #ff5252;
      border: 1px solid #ff5252;
      opacity: 0;
      transform: scale(0.4) rotate(-40deg);
    }
  }

  // hover over the confirm button -> the link breaks
  .cust-card.breaking {
    .cust-chain {
      .main {
        opacity: 0;
        transform: scale(0.4) rotate(40deg);
      }
      .broken {
        opacity: 1;
        transform: scale(1) rotate(0);
        animation: custShake 0.5s;
      }
      .seg {
        border-top-color: #ff5252;
        &.left {
          width: 32%;
        }
        &.right {
          width: 32%;
        }
      }
    }
    .emp .cust-avatar {
      transform: translateX(8px) rotate(-6deg);
    }
    .cus .cust-avatar {
      transform: translateX(-8px) rotate(6deg);
    }
  }

  .cust-notes {
    position: relative;
    list-style: none;
    margin: 0 0 22px;
    padding: 12px 14px;
    text-align: right;
    font-size: 13px;
    color: #546e7a;
    background: #fff;
    border: 1px solid #e3e8f4;
    border-radius: 14px;
    li {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 4px 0;
      i {
        width: 18px;
        text-align: center;
        color: #ff8a80;
      }
    }
  }

  .cust-actions {
    position: relative;
    display: flex;
    gap: 10px;
  }
  .cust-btn {
    height: 46px;
    border: 0;
    border-radius: 14px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: 0.25s;
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
    &.danger {
      flex: 1;
      color: #fff;
      background: linear-gradient(135deg, #ff5252, #d50000);
      box-shadow: 0 10px 24px rgba(255, 82, 82, 0.4);
      &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 14px 28px rgba(255, 82, 82, 0.55);
      }
      i {
        margin-left: 6px;
      }
    }
    &.ghost {
      flex: 0 0 30%;
      color: #546e7a;
      background: transparent;
      border: 1px solid #cfd8dc;
      &:hover:not(:disabled) {
        background: rgba(0, 0, 0, 0.05);
      }
    }
  }
  .cust-spin {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 3px solid rgba(255, 255, 255, 0.4);
    border-top-color: #fff;
    border-radius: 50%;
    animation: custSpin 0.7s linear infinite;
  }
}
// ---- ban switcher (lives inside the table, so scoped styles apply)
.ban-switch {
  position: relative;
  width: 86px;
  height: 34px;
  padding: 0;
  border: 0;
  border-radius: 20px;
  cursor: pointer;
  overflow: hidden;
  color: #fff;
  background: linear-gradient(135deg, #43a047, #1b5e20);
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.25),
    0 4px 12px rgba(67, 160, 71, 0.35);
  transition: background 0.4s, box-shadow 0.4s;
  &:focus-visible {
    outline: 2px solid #1a237e;
    outline-offset: 2px;
  }
  .ban-label {
    position: absolute;
    top: 0;
    line-height: 34px;
    font-size: 12px;
    font-weight: 700;
    transition: opacity 0.3s, transform 0.4s;
    &.on {
      right: 14px;
    }
    &.off {
      left: 12px;
      opacity: 0;
      transform: translateX(-12px);
    }
  }
  .ban-knob {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    transition: transform 0.45s cubic-bezier(0.34, 1.56, 0.64, 1);
    i {
      position: absolute;
      font-size: 13px;
      transition: all 0.3s;
    }
    .ic-on {
      color: #2e7d32;
    }
    .ic-off {
      color: #d50000;
      opacity: 0;
      transform: scale(0.3) rotate(-90deg);
    }
  }
  &:hover:not(.blocked) .ban-knob {
    transform: translateX(3px);
  }
  &:hover.blocked .ban-knob {
    transform: translateX(49px);
  }
  // blocked state: knob slides across, red + pulse
  &.blocked {
    background: linear-gradient(135deg, #ff5252, #b71c1c);
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.25),
      0 4px 12px rgba(255, 82, 82, 0.4);
    animation: banPulse 2.2s infinite;
    .ban-label.on {
      opacity: 0;
      transform: translateX(12px);
    }
    .ban-label.off {
      opacity: 1;
      transform: translateX(0);
    }
    .ban-knob {
      transform: translateX(52px);
      .ic-on {
        opacity: 0;
        transform: scale(0.3) rotate(90deg);
      }
      .ic-off {
        opacity: 1;
        transform: scale(1) rotate(0);
      }
    }
  }
}
@media print {
  .ban-switch {
    display: none;
  }
}

// ban dialog (rendered outside component)
::v-deep .ban-dialog {
  overflow: visible;
  box-shadow: none;
  .ban-card {
    position: relative;
    padding: 56px 26px 24px;
    margin-top: 40px;
    border-radius: 24px;
    text-align: center;
    color: #37474f;
    background: #fff;
    box-shadow: 0 25px 60px rgba(30, 40, 90, 0.25);
    h3 {
      margin: 0 0 10px;
      font-size: 20px;
    }
    p {
      margin: 0 0 6px;
      font-size: 15px;
    }
    small {
      display: block;
      margin-bottom: 22px;
      color: #78909c;
    }
  }
  .ban-icon {
    position: absolute;
    top: -38px;
    left: 50%;
    width: 76px;
    height: 76px;
    margin-left: -38px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    color: #fff;
    border: 5px solid #fff;
    animation: banPop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
  .is-ban {
    h3 {
      color: #c62828;
    }
    .ban-icon {
      background: linear-gradient(135deg, #ff5252, #b71c1c);
    }
    .ban-btn.confirm {
      background: linear-gradient(135deg, #ff5252, #d50000);
      box-shadow: 0 10px 24px rgba(255, 82, 82, 0.4);
    }
  }
  .is-unban {
    h3 {
      color: #2e7d32;
    }
    .ban-icon {
      background: linear-gradient(135deg, #43a047, #1b5e20);
    }
    .ban-btn.confirm {
      background: linear-gradient(135deg, #43a047, #1b5e20);
      box-shadow: 0 10px 24px rgba(67, 160, 71, 0.4);
    }
  }
  .ban-actions {
    display: flex;
    gap: 10px;
  }
  .ban-btn {
    height: 46px;
    border: 0;
    border-radius: 14px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: 0.25s;
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
    &.confirm {
      flex: 1;
      color: #fff;
      &:hover:not(:disabled) {
        transform: translateY(-2px);
      }
    }
    &.ghost {
      flex: 0 0 30%;
      color: #546e7a;
      background: transparent;
      border: 1px solid #cfd8dc;
    }
  }
  .ban-spin {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 3px solid rgba(255, 255, 255, 0.4);
    border-top-color: #fff;
    border-radius: 50%;
    animation: custSpin 0.7s linear infinite;
  }
}
@keyframes banPulse {
  50% {
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.25),
      0 0 0 6px rgba(255, 82, 82, 0.15);
  }
}
@keyframes banPop {
  from {
    transform: scale(0.3);
    opacity: 0;
  }
}
@keyframes custShake {
  25% {
    transform: scale(1) rotate(-12deg);
  }
  75% {
    transform: scale(1) rotate(12deg);
  }
}
@keyframes custSpin {
  to {
    transform: rotate(360deg);
  }
}
</style>
